import { createAction } from "@reduxjs/toolkit";
import { SLICE_NAME } from "./Slice";
export const getProfileTabsAsyncAction = createAction(`${SLICE_NAME}/getProfileTabsAsyncAction`);
